import React from 'react';
import { Link } from 'react-router-dom';
import { TextSnippet } from '../icons';
import './scss/PageBreadcrumbs.scss';

const PageBreadcrumbs = ({ page, allPages, workspaceId }) => {
  // Build breadcrumb trail by traversing parent hierarchy
  const buildBreadcrumbs = () => {
    const breadcrumbs = [];
    let currentPage = page;

    // Traverse up the parent chain
    while (currentPage) {
      breadcrumbs.unshift({
        id: currentPage.shortId,
        title: currentPage.title || 'New page',
        icon: currentPage.icon || '📄'
      });

      // Find parent page
      if (currentPage.parent) {
        currentPage = allPages.find(p => p.shortId === currentPage.parent);
      } else {
        currentPage = null;
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = buildBreadcrumbs();

  // Don't show breadcrumbs if there's only one level (current page)
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className="page-breadcrumbs">
      {/* Pages root link */}
      <Link to={`/w/${workspaceId}/pages`} className="breadcrumb-item">
        <TextSnippet size={16} />
        <span>Pages</span>
      </Link>
      
      <span className="breadcrumb-separator">/</span>

      {/* Page hierarchy */}
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        
        return (
          <React.Fragment key={crumb.id}>
            {isLast ? (
              <span className="breadcrumb-item current">
                <span className="breadcrumb-icon">{crumb.icon || '📄'}</span>
                <span className="breadcrumb-title">{crumb.title || 'Untitled'}</span>
              </span>
            ) : (
              <>
                <Link 
                  to={`/w/${workspaceId}/pages/${crumb.id}`} 
                  className="breadcrumb-item"
                >
                  <span className="breadcrumb-icon">{crumb.icon}</span>
                  <span>{crumb.title}</span>
                </Link>
                <span className="breadcrumb-separator">/</span>
              </>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default PageBreadcrumbs;

